import api from '@/services/api/api';

export const useFilmBySlug = (slug) => {
  const filmSlug = useQuery(
    ['filmSlug', slug],
    async () => {
      const { data } = await api.lectures.getVideoLectureBySlug(slug);
      return data;
    },
    {
      isEnabled: computed(() => !!slug),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await filmSlug.suspense();
  });

  return {
    filmSlug,
  };
};
